import type { ReactNode } from "react";
import { styled } from "styled-components";

import { ListLink } from "common/components/lists/ListLink";
import type { CustomKnowledge } from "domains/customContentAndSources/types";
import { LatestViewInnerContent } from "domains/knowledgeData/components/SharedComponents";
import type { Knowledge } from "entities/knowledge/types";

const StyledLink = styled(ListLink)`
  text-decoration: none;
`;

type KnowledgeDataNavigationalItemLatestViewProps = {
  articleAnnouncement?: ReactNode;
  knowledge: Knowledge | CustomKnowledge;
  link: string;
};

export const KnowledgeDataNavigationalItemLatestView = ({
  link,
  knowledge,
  articleAnnouncement,
}: KnowledgeDataNavigationalItemLatestViewProps) => (
  <StyledLink to={link}>
    <LatestViewInnerContent knowledge={knowledge} link={link} articleAnnouncement={articleAnnouncement} />
  </StyledLink>
);
